import { lazy } from 'react';

const TeamCreateDialogLazyWrapper = lazy(
	() =>
		import(/* webpackChunkName: "async-ptc_team-create-dialog" */ './AkTeamCreateDialogWrapper'),
);

export default TeamCreateDialogLazyWrapper;
